/**
 * @generated SignedSource<<959dc93e98f63a9663953c889c6aaa24>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type DatePickerQuery$variables = {
  end?: string | null;
  start?: string | null;
};
export type DatePickerQuery$data = {
  readonly viewer: {
    readonly dayEvents: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly end: string | null;
          readonly id: string;
          readonly start: string | null;
        };
      } | null>;
    };
  };
};
export type DatePickerQuery = {
  response: DatePickerQuery$data;
  variables: DatePickerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "end"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "start"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": "dayEvents",
  "args": [
    {
      "kind": "Variable",
      "name": "end",
      "variableName": "end"
    },
    {
      "kind": "Variable",
      "name": "start",
      "variableName": "start"
    }
  ],
  "concreteType": "EventConnection",
  "kind": "LinkedField",
  "name": "events",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EventEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Event",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "start",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "end",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DatePickerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DatePickerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1ea7746d2da4cb62f830ca82900a3452",
    "id": null,
    "metadata": {},
    "name": "DatePickerQuery",
    "operationKind": "query",
    "text": "query DatePickerQuery(\n  $end: DateTime\n  $start: DateTime\n) {\n  viewer {\n    dayEvents: events(start: $start, end: $end) {\n      edges {\n        node {\n          id\n          start\n          end\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "d1708ecd89a01f9f91c09f226ef3c6dc";

export default node;
